module.exports = __webpack_public_path__ + "img/sequence-suidobashi-sp@2x.64302c31.jpg";